import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// La página está en español: evita que el navegador ofrezca traducirla y cambie los textos de la planilla.
document.documentElement.lang = "es";
document.documentElement.setAttribute("translate", "no");
if (!document.querySelector('meta[name="google"]')) {
  const meta = document.createElement("meta");
  meta.name = "google";
  meta.content = "notranslate";
  document.head.appendChild(meta);
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-429" data-mp="2k0yuc9x3vgjn" />);
}